module.exports = __webpack_public_path__ + "assets/img/ic-info-blue.c4c7674d.svg";